/**
 * Calculate single viewport height unit in pixels, based on window.innerheight
 * This can be used if exact height is needed, as some mobile browsers calculate vh using outerheight (not taking toolbar into account)
 * Example usage in css: min-height: calc(var(--vh) * 100);
*/

export default function vhCalculation() {

  /**
   * Calculate single vh height in pixels and set css variable
   */
  function calculateVh() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  }

  // Initial calculation
  calculateVh();

  // Re-calculate on resize
  window.addEventListener('resize', calculateVh);
}
